import * as requests from '../requests'
import {fetchSensors, deleteAllSensors} from '../actions/sensors'
import {deleteAllAQIHist} from '../actions/analytics'

import {fetchAllHeatmaps, deleteHeatmaps, errorOnMap} from "./heatmaps";
import {dataLoaded, loadingData} from "./app";

export const FETCH_POLLUTION_AREA = 'FETCH_POLLUTION_AREA'
export const ADD_POLLUTION_AREA = 'ADD_POLLUTION_AREA'
export const EMPTY_POLLUTION_AREA = 'EMPTY_POLLUTION_AREA'
export const ADD_POLLUTION_AREA_POINT = 'ADD_POLLUTION_AREA_POINT'
export const CLOSE_POLLUTION_AREA = 'CLOSE_POLLUTION_AREA'
export const REMOVE_POLLUTION_AREA = 'REMOVE_POLLUTION_AREA'
export const SHOW_POLLUTION_AREA = 'SHOW_POLLUTION_AREA'
export const HIDE_POLLUTION_AREA = 'HIDE_POLLUTION_AREA'
export const CREATING_POLLUTION_AREA = 'CREATING_POLLUTION_AREA'
export const CHANGE_POLLUTION_AREA = 'CHANGE_POLLUTION_AREA'
export const CHANGE_LAYER = 'CHANGE_LAYER'
export const MOVE_POLLUTION_AREA = 'MOVE_POLLUTION_AREA'

export const fetchPollutionArea = (L, leafletElement, admin, map, hours) => {
    return dispatch => {
         var promise = new Promise(function(resolve, reject) {
             requests.getPollutionArea(map, (pollutionArea) => {
                 if (!pollutionArea){
                     dispatch(errorOnMap());
                     return dispatch(emptyPollutionArea(L.polyline([]).addTo(leafletElement)))
                 }else {
                     dispatch(fetchSensors(map))
                     dispatch(fetchAllHeatmaps(resolve, admin, map, hours))
                     dispatch(addPollutionArea(pollutionArea, L, leafletElement, admin))
                 }
             })
         })
    }
}

const addPollutionArea = (pollutionArea, L, leafletElement, admin) => {

    let coordinates = [];

    pollutionArea.coordinates.forEach(coord => {
        coordinates.push(coord);
    });
    let bbox = [pollutionArea.SW, pollutionArea.NE];

    let types = pollutionArea.types;

    return {
        type: ADD_POLLUTION_AREA,
        coordinates,
        L,
        leafletElement,
        admin,
        bbox,
        types
    }
}

const emptyPollutionArea = (polyLineObj) => {
    return {
        type: EMPTY_POLLUTION_AREA,
        polyLineObj
    }
}

export const addPollutionAreaPoint = (polygonPoint) => {
    return {
        type: ADD_POLLUTION_AREA_POINT,
        polygonPoint
    }
}

export const closePollutionArea = () => {
    return {
        type: CLOSE_POLLUTION_AREA
    }
}

const removePollutionArea = () => {
    return {
        type: REMOVE_POLLUTION_AREA
    }
}

export const deletePollutionArea = (map) => {
    return dispatch => {
        requests.deletePollutionArea(map, (status) => {
            dispatch(deleteAllSensors(map))
            dispatch(removePollutionArea())
            //dispatch(deleteHeatmaps())
            deleteAllAQIHist(map)
        })
    }
}

const showPollutionArea = () => {
    return {
        type: SHOW_POLLUTION_AREA
    }
}

export const postPollutionArea = (pollutionArea) => {
    return dispatch => {
        dispatch(loadingData())
        dispatch(showPollutionArea())
        requests.storePollutionArea(pollutionArea, (status) => {
            if (status === 201) dispatch(showPollutionArea())
            dispatch(dataLoaded())
        })
    }
}

export const updatePollutionArea = (id, pollutionArea, L, leafletElement) => {
    return dispatch => {

        requests.updatePollutionArea(id, pollutionArea, (status, poly) => {
            if (status === 200){
                let bbox = [poly.SW, poly.NE];
                dispatch({
                    type: MOVE_POLLUTION_AREA,
                    error: false,
                    coordinates: pollutionArea.location.points,
                    bbox,
                    L,
                    leafletElement
                })
            } else {
                dispatch({
                    type: MOVE_POLLUTION_AREA,
                    error: true
                });
            }
        })
    }
}

export const generateBaseMask = (id) => {
    return dispatch => {
        requests.generateBaseMap(id, (status) => {
            if (status === 200){

            }
        });
    }
}

export const hidePollutionArea = () => {
    return {
        type: HIDE_POLLUTION_AREA
    }
}

export const creatingPollutionArea = () => {
    return {
        type: CREATING_POLLUTION_AREA
    }
}

export const changePollutionArea = (map) => {
    return {
        type: CHANGE_POLLUTION_AREA,
        map
    }
}

export const changeLayer = (layers) => {
    return {
        type: CHANGE_LAYER,
        layers
    }
}


// WEBPACK FOOTER //
// ./src/actions/pollutionAreas.js